if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="country_code"]'),
          button: this.querySelector('#currency-button'),
          close: this.querySelector('#currency-close'),
          close: this.querySelector('#currency-overlay-backdrop'),
          panel: this.querySelector('#currency-dropdown'),
          search: this.querySelector('#currency-search'),
          currencys: this.querySelectorAll('#currency-item')
        };
        // console.log("button" + this.elements.button)
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.close.addEventListener('click', this.closeSelector.bind(this));
        // this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.search.addEventListener('keyup', this.filter.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.querySelectorAll('#currency-item').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      }
  
      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.classList.add('hidden');
      }
  
      filter() {
        const searchValue = this.elements.search.value.toLowerCase();
        this.elements.currencys.forEach(item => {
          const itemName = item.dataset.name.toLowerCase();
          if (searchValue === "" || itemName.includes(searchValue)) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        });
      }
  
      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        this.elements.button.focus();
      }
  
      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        console.log(event.currentTarget.dataset.currency)
        this.elements.input.value = event.currentTarget.dataset.currency;
        if (form) form.submit();
      }
  
      openSelector(event) {
        
        event.preventDefault();
        this.elements.button.focus();
        this.elements.panel.classList.toggle('hidden');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
      }
  
      closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) {
          this.hidePanel();
        }
      }
    }
  );
}
